import { render } from "./ExamGridList.vue?vue&type=template&id=b3c86634&scoped=true"
import script from "./ExamGridList.vue?vue&type=script&lang=js"
export * from "./ExamGridList.vue?vue&type=script&lang=js"

import "./ExamGridList.vue?vue&type=style&index=0&id=b3c86634&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3c86634"]])

export default __exports__